export default __webpack_public_path__ + "static/media/toronto.51bb94e9.png";